<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6ywDeQ/tc-custom/9781504075992.jpg?1726574202410" alt="This image is the cover for the book Undercover Lovers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Undercover Lovers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this steamy paranormal thriller by the bestselling author of <i>The Devil’s Advocate</i>, the CIA enlists the help of a glamorous and powerful vampire.</b></p><p>International supermodel Opal Stone has garnered fame on catwalks around the world, wearing the latest fashions from trendy designers. But only few know her secrets . . .</p><p>There is her lover, agent Sean Waters, who brought her to the CIA as an assassin. There is her personal assistant Mary, who has witnessed what Opal can do to a man with one swipe of her hand. And of course, centuries of living as a vampire have also given her some enemies . . .</p><p>After a surprise before her latest runway show in New York, Opal discovers a vampire hunter is tracking her every move. Not only could he jeopardize her current assignment, but he could also spell the end of everything . . .</p><p><b>Praise for Andrew Neiderman</b></p><p><b>“A master of psychological thrillers.” —V.C. Andrews</b></p><p><b>“An expert weaver of suspense.”—<i>Fresh Fiction</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Neiderman
      </h2>
      
      <p class="authorDescription body article">Andrew Neiderman was born in Brooklyn and grew up in New York&rsquo;s scenic Catskill Mountains region.&#160;A graduate of the University at Albany, State University of New York, from which he also received his master&rsquo;s in English, Neiderman taught at Fallsburg Junior-Senior High School for twenty-three years before pursuing a career as a novelist and screenwriter. He has written more than forty thriller novels under his own name, including&#160;<I>The Devil&rsquo;s Advocate</I>, which was made into a major motion picture for Warner Bros., starring Al Pacino, Keanu Reeves, and Charlize Theron, and is in development as a stage musical in London. Neiderman has also written seventy&#160;<I>New York Times</I>&ndash;bestselling novels for the V. C. Andrews franchise. He lives with his family in Palm Springs, California. Visit him on Facebook and at www.neiderman.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f4a9e63